$(document).ready(function(){
  
  $(document).on('mouseover','.collapsible .slideshow__slide', function(){
    $(this).parents('.collapsible').find('.hover_message').show();
  });

  $(document).on('mouseout','.collapsible .slideshow__slide', function(){
    $(this).parents('.collapsible').find('.hover_message').hide();
  });


  $('body').on('click','.facet-button.button.custom_sort_button',function () {
      $('details.facets-container.custom-facets-sort').removeAttr('open','open');
  })
});

         